// extracted by mini-css-extract-plugin
module.exports = {"input":"ClipboardButton_input_RhzJI"};